export default {
  // 按钮文本
  historyList: "历史列表",
  keyStep: "关键步骤",

  // 标题
  keyStepTitle: "关键步骤",
  historyListTitle: "历史列表",
};
